import script from "./disableOrEnableMember.vue?vue&type=script&setup=true&lang=ts"
export * from "./disableOrEnableMember.vue?vue&type=script&setup=true&lang=ts"

import "./disableOrEnableMember.vue?vue&type=style&index=0&id=e9dc6c68&scoped=true&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9dc6c68"]])

export default __exports__